/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const CustomBullseye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Custom Bullseye 24" clipPath="url(#a)">
      <g className="Fill-Main">
        <path
          fill="#5E1FF0"
          d="M22.493 3.651a1.8 1.8 0 0 0-.33-.255 1.802 1.802 0 0 0-.647-.246c-.06-.01-.115-.025-.18-.03l-.21-.02-.21-.02-.02-.225-.016-.196a1.995 1.995 0 0 0-.045-.25 1.774 1.774 0 0 0-.26-.616c-.065-.1-.14-.195-.23-.286-.721-.72-1.903-.616-2.479-.035-.576.576-.776 1.318-.691 2.57l.015.22c.01.13.025.245.035.356.06.49.15.79.265 1.152.016.045.03.095.05.145.04.125.086.26.136.405.145.046.275.09.4.13.04.016.075.026.116.04.36.12.66.211 1.136.276.18.025.386.045.631.06l.22.01c1.107.045 1.808-.165 2.349-.706.576-.576.68-1.758-.035-2.479Z"
        />
        <path
          fill="#fff"
          fillOpacity={0.8}
          d="M22.493 3.651a1.8 1.8 0 0 0-.33-.255 1.802 1.802 0 0 0-.647-.246c-.06-.01-.115-.025-.18-.03l-.21-.02-.21-.02-.02-.225-.016-.196a1.995 1.995 0 0 0-.045-.25 1.774 1.774 0 0 0-.26-.616c-.065-.1-.14-.195-.23-.286-.721-.72-1.903-.616-2.479-.035-.576.576-.776 1.318-.691 2.57l.015.22c.01.13.025.245.035.356.06.49.15.79.265 1.152.016.045.03.095.05.145.04.125.086.26.136.405.145.046.275.09.4.13.04.016.075.026.116.04.36.12.66.211 1.136.276.18.025.386.045.631.06l.22.01c1.107.045 1.808-.165 2.349-.706.576-.576.68-1.758-.035-2.479Z"
        />
      </g>
      <path
        fill="#000"
        d="M7.155 14.259a2.593 2.593 0 0 0 2.59 2.59 2.593 2.593 0 0 0 2.588-2.59c0-.145-.02-.286-.045-.426l.816-.821c.145.39.225.806.225 1.247a3.597 3.597 0 0 1-3.59 3.59 3.597 3.597 0 0 1-3.59-3.59 3.597 3.597 0 0 1 3.59-3.591c.436 0 .846.08 1.232.225l-.816.822a2.854 2.854 0 0 0-.416-.04 2.593 2.593 0 0 0-2.589 2.589l.005-.005Zm6.1-5.655a6.628 6.628 0 0 0-3.516-1.011 6.672 6.672 0 0 0-6.665 6.666 6.672 6.672 0 0 0 6.665 6.666 6.672 6.672 0 0 0 6.665-6.666c0-1.297-.38-2.51-1.022-3.536l-.726.731a5.6 5.6 0 0 1 .752 2.805 5.668 5.668 0 0 1-5.664 5.664 5.668 5.668 0 0 1-5.663-5.664 5.668 5.668 0 0 1 5.663-5.665c1.012 0 1.963.27 2.79.742l.725-.732h-.005Zm3.62.621a8.695 8.695 0 0 1 1.607 5.034c0 4.818-3.92 8.744-8.738 8.744-4.817 0-8.743-3.926-8.743-8.744s3.921-8.745 8.743-8.745c1.863 0 3.585.591 5.008 1.588l.71-.716a9.674 9.674 0 0 0-5.718-1.873C4.371 4.513 0 8.885 0 14.259c0 5.374 4.371 9.746 9.744 9.746 5.373 0 9.74-4.372 9.74-9.746a9.696 9.696 0 0 0-1.893-5.75l-.711.716h-.005Zm6.364-2.389c-.841.842-1.878 1.007-2.754 1.007-.12 0-.235 0-.35-.01l-.236-.015a7.478 7.478 0 0 1-1.422-.205c-.255-.065-.476-.14-.721-.22-.11-.036-.23-.076-.356-.12l-.45.45-.706.711-.145.145-1.322 1.328-.707.71-1.472 1.478-.71.716-1.793 1.798-.02.02a.448.448 0 0 1-.34.136.513.513 0 0 1-.331-.136c-.005-.005-.015-.01-.02-.015v-.005a.52.52 0 0 1-.15-.345.46.46 0 0 1 .13-.34l1.807-1.819.716-.716 1.473-1.482.706-.712 1.462-1.467.706-.711.46-.461c-.04-.12-.075-.23-.11-.33a6.912 6.912 0 0 1-.4-1.893l-.015-.226c-.076-1.097-.015-2.349.981-3.346C18.177-.265 20-.25 21.046.796c.385.386.646.857.76 1.383.527.12.997.375 1.383.761 1.046 1.047 1.066 2.87.035 3.896h.015Zm-.711-.706c.576-.576.68-1.758-.035-2.479-.1-.1-.215-.185-.33-.255a1.802 1.802 0 0 0-.647-.246c-.06-.01-.115-.025-.18-.03l-.21-.02-.21-.02-.02-.225-.015-.195a2.032 2.032 0 0 0-.046-.25 1.775 1.775 0 0 0-.26-.617c-.065-.1-.14-.195-.23-.285-.721-.722-1.903-.616-2.479-.035-.576.576-.776 1.317-.691 2.569l.015.22c.01.13.025.246.035.356.06.49.15.791.265 1.152.016.045.03.095.05.145.04.125.086.26.136.406.145.045.275.09.4.13.04.015.075.025.116.04.36.12.66.21 1.136.275.18.025.386.045.631.06l.22.01c1.107.046 1.808-.165 2.349-.706Z"
        className="Details"
      />
    </g>
    <defs>
      <clipPath id="a" className="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const CustomBullseyeIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'custom-bullseye-icon'}
      icon={CustomBullseye}
      {...props}
      size={size}
    />
  );
};
